import { contractApi } from '../contractApi';
import { ContractView } from '../types/contractTypes';
import { ContractGetRequest } from '../requests/contractGetRequest';
import { ContractsGetAllRequest } from '../requests/contractsGetAllRequest';
import { ContractUpsertRequest } from '../requests/contractUpsertRequest';

const contractEndpointsInjected = contractApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all contracts
    getAllContracts: builder.query<ContractView[], ContractsGetAllRequest>({
      query: ({ company }) => ({
        url: 'Contracts',
        method: 'GET',
        params: { company },
      }),
      providesTags: ['ContractList'],
    }),

    // Get contract by ID
    getContract: builder.query<ContractView, ContractGetRequest>({
      query: ({ id, company }) => ({
        url: 'Contract',
        params: { id, company },
      }),
      providesTags: (result, error, { id }) => [{ type: 'Contract', id }, 'Contract'],
    }),

    // Upsert contract (create or update)
    upsertContract: builder.mutation<ContractView, ContractUpsertRequest>({
      query: (body) => ({
        url: 'Contract',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, body) => [
        ...(body.contract.id ? [{ type: 'Contract' as const, id: body.contract.id }] : []),
        'Contract',
        'ContractList',
      ],
    }),
  }),
  overrideExisting: false,
});

// Export enhanced API for slice extraReducers
export const contractEndpoints = contractEndpointsInjected;

export const {
  useGetAllContractsQuery,
  useGetContractQuery,
  useUpsertContractMutation,
} = contractEndpointsInjected;
